import {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {useQueryClient} from '@tanstack/react-query';

import {ROUTES} from '@/root/constants/routes';
import {cardsKeys, useCardGroupByCardId} from '@/root/queries/cards';
import {useCardGroupStore} from '@/root/stores/cardGroup';

import useAdvancedNavigate from '@/shared/hooks/useAdvancedNavigate';

const RedriectToCardGroupPageByCardId = () => {
  const queryClient = useQueryClient();
  const {cardId = ''} = useParams<{cardId: string}>();
  const navigate = useAdvancedNavigate();
  const {setCardId} = useCardGroupStore();
  const {cardGroup} = useCardGroupByCardId(cardId);

  useEffect(() => {
    setCardId(cardId);
    queryClient.setQueryData(cardsKeys.group(cardGroup.group.code), cardGroup);
    navigate(`${ROUTES.CARD_GROUP}/?initialCardId=${cardId}`, {
      pathParams: {groupCode: cardGroup.group.code},
      replace: true,
      keepSearchParams: true
    });
  }, []);

  return <></>;
};

export default RedriectToCardGroupPageByCardId;
